@if (!isEmpty(get(multipleColumnsRow, 'multi_column_v2', ''))) {
  @for (row of get(multipleColumnsRow, 'multi_column_v2.multi_column_v2', []); track row) {
    <div
        [ngStyle]="{
            'background-color': get(multipleColumnsRow, 'multi_column_v2.exxcom_color_picker', ''),
            'background-repeat': 'no-repeat'
        }"
      >
      @if (!isEmpty(get(row, 'columns'))) {
        <section id="rows" class="container px-3">
          <div class="multi-column-container">
            @if (!isEmpty(get(row, 'multicolumn_content_title', '')) || !isEmpty(get(row, 'subtitle', ''))) {
              <div class="multi-column-title">
                <h2 class="text-center title mb-3">
                  {{ get(row, 'multicolumn_content_title', '') }}
                </h2>
                <p class="multi-column-subtitle my-0 text-center">
                  {{ get(row, 'subtitle', '') }}
                </p>
              </div>
            }
            <div class="multi-columns-sub-container" [ngClass]="'column-' + get(row, 'columns_number')">
              @for (column of get(row, 'columns', ''); track column) {
                <div class="multi-column" [class.card]="get(column, 'enable_card', '')">
                  @if (get(column, 'image.href', '') !== '') {
                    <div class="image-container">
                      @if (!get(column, 'image_enlargement') && !get(column, 'image_link.routerLink', '')) {
                        <img
                          [src]="getWebpImg(get(column, 'image.href', ''))"
                          [alt]="get(column, 'image.title', '')"
                          />
                      }
                      @if (get(column, 'image_link.routerLink', '') && !get(column, 'image_enlargement')) {
                        <a
                          [routerLink]="get(column, 'image_link.routerLink', '')"
                          [queryParams]="get(column, 'image_link.queryParams', '')"
                          >
                          <img [src]="getWebpImg(get(column, 'image.href', ''))" [alt]="get(column, 'image.title', '')" />
                        </a>
                      }
                    </div>
                  }
                  @if (get(column, 'image_enlargement')) {
                    <app-image-zoom
                      [image]="getWebpImg(get(column, 'image.href', ''))"
                      [altText]="get(column, 'image.title', '')"
                      style="width: 100%"
                      >
                      <div class="image-container">
                        @if (get(column, 'image_enlargement')) {
                          <img
                            [src]="getWebpImg(get(column, 'image.href', ''))"
                            [alt]="get(column, 'image.title', '')"
                            />
                        }
                      </div>
                    </app-image-zoom>
                  }
                  <div class="text-components-container">
                    @if (get(column, 'column_title_group', '') && get(column, 'column_title_group.column_title', '') !== '') {
                      <h4
                        class="column-title w-100"
                                [ngStyle]="{
                                    'text-align': get(column, 'column_title_group.column_title_alignment', '')
                                }"
                        >
                        {{ get(column, 'column_title_group.column_title', '') }}
                      </h4>
                    }
                    @if (get(column, 'column_copy_group.enable_copy', '')) {
                      <div class="copy-container">
                        @if (get(column, 'column_copy_group.column_copy', '') !== '') {
                          <p class="column-copy">
                            {{ get(column, 'column_copy_group.column_copy', '') }}
                          </p>
                        } @else {
                          <div
                            [innerHTML]="get(column, 'column_copy_group.rich_text_editor', '') | safe: 'html'"
                            class="rich-content-container"
                          ></div>
                        }
                      </div>
                    }
                    @if (get(column, 'column_button.enable_button', false) && get(column, 'column_button.link.routerLink', '') != '') {
                      <a
                        [routerLink]="get(column, 'column_button.link.routerLink', '')"
                        [queryParams]="get(column, 'column_button.link.queryParams', '')"
                        >
                        @if (get(column, 'column_button.marketo_form_selection.form_selection', '') == 'no_form') {
                          <button
                            class="button-primary button-base d-flex align-items-center w-100 learn-more-button mt-1"
                            tabindex="-1"
                            >
                            {{ get(column, 'column_button.link.title', '') }}
                            <mat-icon>chevron_right</mat-icon>
                          </button>
                        }
                      </a>
                    }
                    @if (get(column, 'column_button.enable_button', false) == true) {
                      @if (get(column, 'column_button.marketo_form_selection.form_selection', '') == 'default_form') {
                        <button-component
                          data-cy="marketo-form"
                                    (click)="
                                        solutionID && bootstrapMarketoService.openBootstrapMarketoDialog(solutionID, 'edit', {
                                            title: dataTitle,
                                            url: dataUrl
                                        })
                                    "
                                    [buttonOptions]="{
                                        text: column.column_button.link.title,
                                        type: 'primary',
                                        iconPosition: 'right',
                                        iconName: 'chevron-right',
                                        class: 'w-100',
                                        disabled: !solutionID
                                    }"
                        ></button-component>
                      }
                      @if (get(column, 'column_button.marketo_form_selection.form_selection', '') == 'other_form') {
                        <button-component
                          data-cy="marketo-form"
                                    (click)="
                                        get(column, 'column_button.marketo_form_selection.marketo_forms.id', '') && bootstrapMarketoService.openBootstrapMarketoDialog(
                                            get(column, 'column_button.marketo_form_selection.marketo_forms.id', ''),
                                            'edit',
                                            {
                                                title: dataTitle,
                                                url: dataUrl
                                            }
                                        )
                                    "
                                    [buttonOptions]="{
                                        text: column.column_button.link.title,
                                        type: 'primary',
                                        iconPosition: 'right',
                                        iconName: 'chevron-right',
                                        class: 'w-100',
                                        disabled: !get(column, 'column_button.marketo_form_selection.marketo_forms.id', '')
                                    }"
                      ></button-component>
                    }
                  }
                </div>
              </div>
            }
          </div>
        </div>
      </section>
    }
  </div>
}
}
@if (get(multipleColumnsRow, 'multi_column_v2.split_line', '')) {
  <hr class="m-0 mb-3" />
}
